import { ICONS, type IconName } from './icons';

/** Renderiza um ícone do conjunto do app (sem wrapper de layout). */
export function Icon({ name }: { name: IconName }) {
  return <span style={{ display: 'contents' }} dangerouslySetInnerHTML={{ __html: ICONS[name] }} />;
}
